import { formatPluralLabel } from './format-plural-label.util'

const formatMinutesDuration = (totalMinutes = 0) => {
  const safeMinutes = Math.max(0, Number(totalMinutes) || 0)
  const hours = Math.floor(safeMinutes / 60)
  const minutes = safeMinutes % 60

  if (hours === 0) {
    return formatPluralLabel(minutes, 'minuto', 'minutos')
  }

  if (minutes === 0) {
    return formatPluralLabel(hours, 'hora', 'horas')
  }

  return `${formatPluralLabel(hours, 'hora', 'horas')} e ${formatPluralLabel(minutes, 'minuto', 'minutos')}`
}

export { formatMinutesDuration }
